function loadScript(url, className) {
  if (!document || !url || typeof url !== "string") return;
  if (document.querySelectorAll(".".concat(className, "[src=\"").concat(url, "\"]")).length > 0) {
    return;
  }
  var svg = document.createElement("script");
  svg.setAttribute("class", className);
  svg.setAttribute("src", url);
  document.body.appendChild(svg);
}
function loadLink(url, className) {
  if (!document || !url || typeof url !== "string") return;
  if (document.querySelectorAll(".".concat(className, "[href=\"").concat(url, "\"]")).length > 0) {
    return;
  }
  var link = document.createElement("link");
  link.setAttribute("class", className);
  link.setAttribute("href", url);
  link.setAttribute("rel", "stylesheet");
  document.head.appendChild(link);
}
function loadStylesheet() {
  var styleSheetId = "__TDESIGN_ICON_STYLE__";
  var iconStyleString = "@keyframes t-spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  .t-icon {\n    display: inline-block;\n    vertical-align: middle;\n    width: 1em;\n    height: 1em;\n  }\n  .t-icon::before {\n    font-family: unset;\n  }\n  .t-icon-loading {\n    animation: t-spin 1s linear infinite;\n  }\n  .t-icon {\n    fill: currentColor;\n  }\n  .t-icon.t-size-s,\n  i.t-size-s {\n    font-size: 14px;\n  }\n  .t-icon.t-size-m,\n  i.t-size-m {\n    font-size: 16px;\n  }\n  .t-icon.t-size-l,\n  i.t-size-l {\n    font-size: 18px;\n  }\n  ";
  if (!document || document.getElementById(styleSheetId)) return;
  var styleSheet = document.createElement("style");
  styleSheet.setAttribute("id", styleSheetId);
  styleSheet.innerHTML = iconStyleString;
  document.head.appendChild(styleSheet);
}

export { loadLink, loadScript, loadStylesheet };
//# sourceMappingURL=check-url-and-load.js.map
